import { Menu, MenuButton, MenuList, MenuItem, Box } from "@chakra-ui/react";
import { FaQuestion } from "react-icons/fa";
import { questionMenuData } from "./QuestionMenuData";

function QuestionMenu() {
  return (
    <Box position="fixed" zIndex={12} top={["93%", "93%", "93%", "93%"]} left={["82%", "90%", "93%", "96%"]}>
      <Box
        position="relative"
        fontFamily="'IBM Plex Mono', monospace"
        fontWeight="normal"
      >
        <Menu placement="top">
          <MenuButton>
            <Box rounded="full" p="2" bg="rgb(0 0 0 / 85%)">
              <FaQuestion color="rgba(245, 245, 245, 1)" />
            </Box>
          </MenuButton>
          <MenuList
            mr={["6", "6", "6", "10"]}
            borderRadius="md"
            bg="rgb(0 0 0 / 85%)"
          >
            {questionMenuData.map(({ name, path, target }) => (
              <MenuItem
                bg="rgb(0 0 0 / 1%)"
                color="rgba(245, 245, 245, .7)"
                _hover={{ color: "rgba(245, 245, 245, 1)" }}
                fontSize="sm"
                key={name}
              >
                <a
                  href={path}
                  target={target ? "_blank" : "_parent"}
                  rel="noreferrer"
                >
                  {name}
                </a>
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      </Box>
    </Box>
  );
}

export default QuestionMenu;
